import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutePlanningContainerComponent } from './containers/route-planning/route-planning-container.component';
import { SearchLineResultsContainerComponent } from './containers/route-planning/route-planning-results-container/search-line-results-container/search-line-results-container.component';
import { resultsTabGuard } from './guards/results-tab.guard';
import { eTab } from './enums/route-planning/tabs/tabs.enums';

const routes: Routes = [
  {
    path: '',
    component: RoutePlanningContainerComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoutePlannerRoutingModule {}
